import { render, staticRenderFns } from "./list-prize-result.vue?vue&type=template&id=51d0322e"
import script from "./list-prize-result.vue?vue&type=script&lang=js"
export * from "./list-prize-result.vue?vue&type=script&lang=js"
import style0 from "./list-prize-result.vue?vue&type=style&index=0&id=51d0322e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports